const storeName = window.Shopify.shop.replace('.myshopify.com', '');

window.sentryOnLoad = function () {
  Sentry.init({
    dsn: "https://593a94aa8f8ba3b9849f63510b621472@o5438.ingest.us.sentry.io/4508495726116864",
    environment: storeName,
    ignoreErrors: [
      "*Error: Retry count of 5 exceeded*",
      "*NetworkError*",
      "*The call to the server was not successful*",
      "*Share canceled*",
      "*h(events)*",
      "*shop_events*",
      "*monorail*",
      "*masked-url*",
      "*shopifycloud/media-analytics*",
      "*wpm*",
      "*shopify-storefront*",
      "*__puppeteer*",
      "*cdn/shopifycloud*",
      "*Monorail*",
      "*Resource blocked*",
      "*handle_abandonment_event*",
      "*onsite/js*",
      "*maps*",
      "*anonymous*",
      "*window.crypto.randomUUID*",
      "*discountmanager*",
      "*BV._render*",
      "*bazaarvoice*",
      "*?(bv)*",
      "*(bv)*",
      "*/bv.js*",
      "*/bvapi.js*",
      "*/bv-primary.js*",
      "*/bv-analytics.js*",
      "*/bazaarvoice.com*",
      "*/inline_ratings/*",
      "*magical-product-fees*",
      "*otBanner*",
      "*@shopify/monorail*",
      "*/apps/*",
      "*/widget/*",
      "*/gtm-suite.js*",
      "*/events.js*",
      "*/fbevents.js*",
      "*/jquery.min.js*",
      "*/bundle.js*",
      "*/affirm.js*",
      "*swat_questions*",
      "*widget-3*",
      "*WKWebView*",
    ],
    allowUrls: [location.origin],
    sendClientReports: false,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
};
